export const sanitizeNumericInput = (input, maxLength = 3) => {
    let sanitizedValue = input
        ?.split("")
        ?.filter((char) => !isNaN(char) && char !== " ")
        ?.join("");

    return sanitizedValue?.slice(0, maxLength);
};